import i18n from '@/i18n/i18n';
import { store } from '@store/store';
import {
    showBlockingError as showBlockingErrorAction,
    clearBlockingError as clearBlockingErrorAction,
} from '@store/slices/blockingErrorSlice';

export function extractErrorMessage(error) {
    const data = error?.response?.data;

    if (!data) {
        return error?.message || i18n.t('common.errorMessage');
    }

    if (typeof data === 'string') {
        return data;
    }

    if (data instanceof Blob) {
        return i18n.t('common.errorMessage');
    }

    return data.message || data.error || data.detail || i18n.t('common.errorMessage');
}

export function showBlockingError(message) {
    const { isOpen } = store.getState().blockingError;
    if (isOpen) {
        return;
    }

    store.dispatch(showBlockingErrorAction(message));
}

export function clearBlockingError() {
    store.dispatch(clearBlockingErrorAction());
}

const PERMISSION_DENIED_STATUS = 401;

export function isPermissionDeniedError(error) {
    return error?.response?.status === PERMISSION_DENIED_STATUS;
}

export function shouldBlockReadAccessError(error, config = {}) {
    if (config.meta?.skipBlockingError) {
        return false;
    }

    const method = (config.method || 'get').toLowerCase();

    return isPermissionDeniedError(error) && ['get', 'head'].includes(method);
}

export function shouldBlockFetchError(error, options = {}) {
    if (!options.blockingError) {
        return false;
    }

    return isPermissionDeniedError(error);
}

export const BLOCKING_FETCH_OPTIONS = { blockingError: true };

export function rejectBlockingFetchError(error, rejectWithValue, fallbackMessage, options = BLOCKING_FETCH_OPTIONS) {
    if (shouldBlockFetchError(error, options)) {
        showBlockingError(extractErrorMessage(error));
        return rejectWithValue({ blocked: true });
    }

    return rejectWithValue({
        message: extractErrorMessage(error) || fallbackMessage,
    });
}
